<template>
  <div class="staffGroup-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加组织机构</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加组织机构"
           @on-ok="createBrand('brandValidate')"
           :loading="loading">
      <Form :model="brand"
            ref="brandValidate"
            :rules="brandValidate"
            action="javascript:void(0)">
        <FormItem label="组织机构名称"
                  prop="name">
          <Input v-model="brand.name"
                 placeholder="输入组织机构名称..."></Input>
        </FormItem>
        <FormItem label="折扣%"
                  prop="discount"
                  style="width:100px;">
          <Input v-model="brand.discount"
                 placeholder="输入折扣..."></Input>
        </FormItem>

        <FormItem label="是否使用唯一二维码"
                  label-position="top">
          <RadioGroup v-model="brand.power">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="最多领取数量"
                  style="width:100px;"
                  v-if="this.brand.power==1">
          <Input v-model="brand.lingqu_num"
                 placeholder="输入数量..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改组织机构"
           @on-ok="updateBrand('brandValidate')"
           :loading="loading">
      <Form :model="brand"
            ref="brandValidate"
            :rules="brandValidate"
            action="javascript:void(0)">
        <FormItem label="组织机构名称"
                  prop="name">
          <Input v-model="brand.name"
                 placeholder="输入组织机构名称..."></Input>
        </FormItem>
        <FormItem label="折扣%"
                  prop="discount">
          <Input v-model="brand.discount"
                 placeholder="输入折扣..."></Input>
        </FormItem>

        <FormItem label="开启权限"
                  label-position="top">
          <RadioGroup v-model="brand.power">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="最多领取数量"
                  style="width:100px;"
                  v-if="this.brand.power==1">
          <Input v-model="brand.lingqu_num"
                 placeholder="输入数量..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'staffGroup-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      sourcelist: [
        { id: 1, name: "通用" },
        { id: 2, name: "锦盒" },
        { id: 3, name: "定制" },
        { id: 4, name: "兑换" },
        { id: 5, name: "约看" }
      ],
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '标题',
          key: 'name',
          fixed: 'left'
        },

        {
          title: '操作',
          key: 'action',
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      formItem: {

      },
      tablelist: [],
      brand: {
        name: '',
        discount: 0,
        power: "0",
        lingqu_num: "1"
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      brandValidate: {
        name: [
          { required: true, message: '组织机构名称必须填写', trigger: 'blur' }
        ]
      },
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var self = this;
      this.$api.staffGroup.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          self.pages.total = res.result.total
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.brand = {
        name: '',
        discount: 0,
        power: "0",
        lingqu_num: "1"
      }
      this.$refs['brandValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand (name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.staffGroup.create({ name: this.brand.name, discount: this.brand.discount, power: this.brand.power, lingqu_num: this.brand.lingqu_num }).then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.brand.name = '';
              this.getTableList();
            }
          });
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    //展开修改
    showEditInfo: function (index) {
      this.groupid = index;
      this.$refs['brandValidate'].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.staffGroup.detail({ groupid: index }).then(res => {
        if (res.code == 200) {
          this.brand = res.result;
          this.brand.power = res.result.power.toString();
          this.brand.lingqu_num = res.result.lingqu_num.toString();
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => { this.loading = true; });
      });
    },
    // 修改名称
    updateBrand: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          console.log(this.brand);
          this.$api.staffGroup.edit({ groupid: this.groupid, name: this.brand.name, discount: this.brand.discount, power: this.brand.power, lingqu_num: this.brand.lingqu_num }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.showEditInfoStatus = !this.showEditInfoStatus;
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => { this.loading = true; });
            this.showCreateStatus = !this.showCreateStatus;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.getTableList();
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.staffGroup.remove({ groupid: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
  },
}
</script>
